import { render, staticRenderFns } from "./PlantillaImpresion.vue?vue&type=template&id=12266491&scoped=true&"
import script from "./PlantillaImpresion.vue?vue&type=script&lang=js&"
export * from "./PlantillaImpresion.vue?vue&type=script&lang=js&"
import style0 from "./PlantillaImpresion.vue?vue&type=style&index=0&id=12266491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12266491",
  null
  
)

export default component.exports